/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEqual } from 'lodash';
import { versionReleasesTypes } from '../reduxExports';
import rmsStore from '../rmsStore';
import { isAxiosError } from 'axios';
import hwaxios from '../api-service/HWAxios';

const url = process.env.REACT_APP_SERVER_BASE_URL;

export const fetchVersionReleaseListData: any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_VERSION_RELEASE_TABLE_LIST_LOADER,
          versionReleaseTableListLoader: true
        };
        dispatch(loaderStartAction);

        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
          ? reqBody.searchTerm.trim() : null;

        const filterHash = reqBody?.filters;

        const hashAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_VERSION_RELEASE_LIST_REQUEST_HASH,
          versionReleaseListRequestSearchHash: searchHash,
          versionReleaseListRequestFilterHash: filterHash
        };
        dispatch(hashAction);

        const response = await hwaxios.post(url + '/software-release/list', reqBody)
        if (
          searchHash === rmsStore.getState().versionReleasesReducer.versionReleaseListRequestSearchHash &&
          isEqual(filterHash, rmsStore.getState().versionReleasesReducer.versionReleaseListRequestFilterHash)
        ) {
          const action = {
            type: versionReleasesTypes.FETCH_VERSION_RELEASE_DATA,
            versionReleases: response.data?.data?.softwareReleases,
            versionReleasesCount: response.data?.data?.softwareReleasesCount,
          };
          dispatch(action);
        }

        if (response?.status === 200) {
          const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_VERSION_RELEASE_TABLE_LIST_LOADER,
            versionReleaseTableListLoader: false
          };
          dispatch(loaderEndAction);
        }
      } catch (error) {
        const loaderEndAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_VERSION_RELEASE_TABLE_LIST_LOADER,
          versionReleaseTableListLoader: false
        };
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    };


export const setVersionReleaseTableProps: any = (data) => async (dispatch: (arg0: Partial<VersionReleaseAction>) => void): Promise<void> => {
  const action = {
    type: versionReleasesTypes.SET_VERSION_RELEASE_TABLE_PROPS,
    versionReleaseTableProps: data,
  };
  dispatch(action);
};

export const exportVersionReleaseListData: any = (reqParams) => async (): Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/software-release/export', reqParams);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      };
    }
  }
}


export const createSoftwareVersion: any = (reqBody) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/software-release', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      };
    }
  }
}


export const setRedirectedStateForVersionReleasesFilters: any = (data) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: versionReleasesTypes.SET_VERSION_RELEASE_FILTERS_APPLIED_FROM_REDIRECTION,
        versionReleaseFiltersAppliedFromRedirection: data,
      };
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};


export const fetchChargerOnVersionTrendList: any = (reqBody) =>
  async (dispatch: (arg0: Partial<VersionReleaseAction>) => void): Promise<void> => {
    const productTypeHash = reqBody?.productType || '';
    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<VersionReleaseAction> = {
      type: versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_FILTER_HASH,
      chargerOnVersionTrendProductTypeHash: productTypeHash,
      chargerOnVersionTrendFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const loaderStartAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_LOADER,
          chargerOnVersionTrendLoader: true
        };
        dispatch(loaderStartAction);
      const response = await hwaxios.post(url + '/software-release/sw-charger', reqBody);
      if (productTypeHash === rmsStore.getState().versionReleasesReducer.chargerOnVersionTrendProductTypeHash && isEqual(reqFilterHash, rmsStore.getState().versionReleasesReducer.chargerOnVersionTrendFilterHash)) {
        const action: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.FETCH_CHARGER_ON_VERSION_TREND_DATA,
          chargerOnVersionTrendInfo: response.data?.data,
        };
        dispatch(action);
      }
      if(response?.status===200){
        const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_LOADER,
            chargerOnVersionTrendLoader: false
          };
          dispatch(loaderEndAction);
      }
    } catch (error) {
      const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_LOADER,
            chargerOnVersionTrendLoader: false
          };
          dispatch(loaderEndAction);
      console.error(error);
      throw error;
    }
  };


export const fetchLatestVersionInfoData: any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_LATEST_VERSION_INFO_LOADER,
          latestVersionInfoLoader: true
        };
        dispatch(loaderStartAction);
        const response = await hwaxios.post(url + '/software-release/dashoboard', reqBody)
        const responseData = response?.data?.data;
        const action: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.FETCH_LATEST_VERSION_INFO_DATA,
          latestVersionInfo: responseData
        }
        dispatch(action)

        if(response?.status===200){
        const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_LATEST_VERSION_INFO_LOADER,
            latestVersionInfoLoader: false
          };
          dispatch(loaderEndAction);
      }
      } catch (error) {
        const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_LATEST_VERSION_INFO_LOADER,
            latestVersionInfoLoader: false
          };
          dispatch(loaderEndAction)
        console.error(error)
        throw (error)
      }
    };


export const fetchDeploymentProgressTrendList: any = (reqBody) =>
  async (dispatch: (arg0: Partial<VersionReleaseAction>) => void): Promise<void> => {

    const productTypeHash = reqBody?.productType || '';
    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<VersionReleaseAction> = {
      type: versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_FILTER_HASH,
      deploymentProgressTrendProductTypeHash:productTypeHash,
      deploymentProgressTrendFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const loaderStartAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_LOADER,
          deploymentProgressTrendLoader: true
        };
        dispatch(loaderStartAction);
      const response = await hwaxios.post(url + '/software-release/version-vs-date', reqBody);
      if (productTypeHash === rmsStore.getState().versionReleasesReducer.deploymentProgressTrendProductTypeHash && isEqual(reqFilterHash, rmsStore.getState().versionReleasesReducer.deploymentProgressTrendFilterHash)) {
        const action: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.FETCH_DEPLOYMENT_PROGRESS_TREND_DATA,
          deploymentProgressTrendInfo: response.data?.data,
        };
        dispatch(action);
      }
      if(response?.status === 200){
        const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_LOADER,
          deploymentProgressTrendLoader: false
          };
          dispatch(loaderEndAction);
      }
    } catch (error) {
      const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_LOADER,
          deploymentProgressTrendLoader: false
          };
          dispatch(loaderEndAction);
      console.error(error);
      throw error;
    }
  };


export const fetchDeploymentLogsListData: any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER,
          deploymentLogTableListLoader: true
        };
        dispatch(loaderStartAction);

        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
          ? reqBody.searchTerm.trim() : null;

        const filterHash = reqBody?.filters;

        const hashAction: Partial<VersionReleaseAction> = {
          type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_LIST_REQUEST_HASH,
          deploymentLogListRequestSearchHash: searchHash,
          deploymentLogListRequestFilterHash: filterHash
        };
        dispatch(hashAction);

        const response = await hwaxios.post(url + '/software-release/history', reqBody)
        
        if (
          searchHash === rmsStore.getState().versionReleasesReducer.deploymentLogListRequestSearchHash &&
          isEqual(filterHash, rmsStore.getState().versionReleasesReducer.deploymentLogListRequestFilterHash)
        ) {
          const action = {
            type: versionReleasesTypes.FETCH_DEPLOYMENT_LOGS_DATA,
            deploymentLogs: response.data?.data?.softwareUpdateLogs,
            deploymentLogsCount: response.data?.data?.softwareUpdateLogsCount,
          };
          dispatch(action);
        }

        if (response?.status === 200) {
          const loaderEndAction: Partial<VersionReleaseAction> = {
            type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER,
            deploymentLogTableListLoader: false
          };
          dispatch(loaderEndAction);
        }
      } catch (error) {
        const loaderEndAction: Partial<VersionReleaseAction> = {
         type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER,
          deploymentLogTableListLoader: false
        };
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    };

export const setDeploymentLogsTableProps: any = (data) => async (dispatch: (arg0: Partial<VersionReleaseAction>) => void): Promise<void> => {
  const action = {
    type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_PROPS,
    deploymentLogTableProps: data,
  };
  dispatch(action);
};


export const setRedirectedStateForDeploymentLogsFilters: any = (data) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: versionReleasesTypes.SET_DEPLOYMENT_LOGS_FILTERS_APPLIED_FROM_REDIRECTION,
        deploymentLogsFiltersAppliedFromRedirection: data,
      };
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};

